<mat-card appearance="outlined" *ngIf="reportForm" class="email-customization">
  <form [formGroup]="reportForm">
    <mat-card-title class="tw-flex tw-justify-between">
      <span>{{ 'monitoring.profile.item.contentCustomization.title' | translate }}</span>
      <ui-svg-icon
        *ngIf="isDeviationVisible"
        [name]="iconNameList.AlertInfo"
        [width]="32"
        class="delay-info tw-ml-auto"
        [matTooltip]="
          ('common.field.delayInfo' | translate) +
          ':' +
          '&#13;' +
          '&#13;' +
          ('common.field.sea' | translate) +
          '&#160;' +
          ' > ' +
          '&#160;' +
          delayTypeValue.Sea +
          ' ' +
          ('common.field.suffix.hours' | translate) +
          '&#13;' +
          ('common.field.road' | translate) +
          '&#160;' +
          ' > ' +
          '&#160;' +
          delayTypeValue.Road +
          ' ' +
          ('common.field.suffix.hours' | translate) +
          '&#13;' +
          ('common.field.air' | translate) +
          '&#160;' +
          ' > ' +
          '&#160;' +
          delayTypeValue.Air +
          ' ' +
          ('common.field.suffix.hours' | translate)
        "
      ></ui-svg-icon>
      <mat-slide-toggle
        *ngIf="reportForm.get('includeAllFields')"
        formControlName="includeAllFields"
        class="tw-self-center tw-ml-2"
        color="primary"
      >
        {{ 'common.field.all' | translate }}
      </mat-slide-toggle>
    </mat-card-title>

    <div *ngIf="isDeviationVisible" class="email-customization__type">
      <div class="email-customization__label">
        {{ 'common.field.type' | translate }}
      </div>

      <mat-button-toggle-group formControlName="type">
        <mat-button-toggle
          *ngFor="let type of [reportType.Delay, reportType.Early, reportType.Both]"
          [value]="type"
          aria-label="{{ type }}"
        >
          {{ 'common.button.' + type.toLowerCase() | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="email-customization__items-wrapper">
      <ui-monitoring-report-item
        *ngFor="let name of reportItemNameList"
        [label]="'monitoring.profile.item.' + name | translate"
        [name]="name"
        [reportFormControl]="reportForm.get(name)"
        [reportItemList]="report[name]"
        [removable]="isSubscriptionEnabled"
        [isDisabled]="reportForm.get('includeAllFields')?.value"
        [maxFieldsCount]="maxFieldsCount"
      ></ui-monitoring-report-item>
    </div>
  </form>
</mat-card>
